import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "fun vs. reason",
  "description": "",
  "published": "2011-11-12T00:00:00.000Z",
  "redirect_from": ["/blog/?p=2915"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I don't want to do things for a reason, I want to do them because it's fun.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      